const triggerModal = {
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&',
  },
  templateUrl: '/modules/pis-tool/conditions/condition-form/trigger-form/trigger-modal/trigger-modal.html',
  controller: 'TriggerModalController',
};

angular
  .module('pis-tool.module')
  .component('triggerModal', triggerModal);
